const Barba = require('barba.js');


const ExcuseTransition = Barba.BaseTransition.extend({
    start() {
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.hideOldContainer.bind(this))
            .catch(error => console.log(`Error(ExcuseTransition): ${error}`))
            .finally(this.done.bind(this));
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        return prev.namespace === 'excuse';
    },

    fadeOut() {
        const $excuseRow = $(this.oldContainer).find('.excuse__row');

        return new Promise(resolve => $excuseRow.animateCss('fadeOut', resolve));
    },

    hideOldContainer() {
        return new Promise((resolve) => {
            $(this.oldContainer).hide();
            $(this.newContainer).css('visibility', 'visible');
            resolve();
        });
    },
});


const FromHomeTransition = Barba.BaseTransition.extend({
    start() {
        Promise
            .all([this.newContainerLoading, this.hideScroll()])
            .then(this.scrollDownOut.bind(this))
            .catch(error => console.log(`Error(FromHomeTransition): ${error}`))
            .finally(this.done.bind(this));
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        return prev.namespace === 'home';
    },

    hideScroll() {
        const $body = $('body');

        return new Promise((resolve) => {
            $body.css('overflow', 'hidden');
            resolve();
        });
    },

    scrollDownOut() {
        return new Promise(resolve => $(this.oldContainer).animateCss('homeOut', resolve));
    },
});


export default class Transition {
    constructor() {
        Barba.Pjax.getTransition = () => {
            if (FromHomeTransition.valid()) {
                return FromHomeTransition;
            }

            return ExcuseTransition;
        };
    }
}



// WEBPACK FOOTER //
// ./frontend/js/transition.js